// *页面name  不要随意更改 有地方用来做判断了
import i18n from '@/i18n/locale';
export default [
  // 订单列表
  {
    path: '/order-list',
    name: 'OrderList',
    meta: {
      title: i18n.t('FoodC_part3_Order_List_uPvS'),
      sideMenu: {
        weight: 60,
        label: i18n.t('FoodC_part3_Order_List_uPvS'),
        icon: 'icon-filled_order',
        type: 3,
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "orderList" */
        '@/views/OrderList.vue'
      ),
  },
  {
    path: '/order-download',
    name: 'OrderDownload',
    meta: {
      title: i18n.t('Entrega_orderlist__pKjE'),
      sidebar: {
        visible: false,
      },
      footer: {
        visible: false,
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "orderList" */
        '@/views/OrderDownload.vue'
      ),
  },
  {
    path: '/order-detail',
    name: 'OrderDetail',
    meta: {
      title: i18n.t('FoodC_revision_Order_Details_aiDd'),
      sidebar: {
        visible: false,
      },
      footer: {
        visible: false,
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "orderDetail" */
        '@/views/OrderDetail.vue'
      ),
  },
];
